import axios from '@axios'
import { control } from 'leaflet'

export default {
    namespaced: true,
    state: {
        usuarios: [],
        reporte: [],
        datos: [],
        empresas: [],
        //roles: [],
        plantas: [],
        kardex: [],
        stock: [],
        user: [],
        movimientos: [],
        binMov: [],
        colores: [],
        monitoreo: [],
        camaroneras: [],
        piscinas: [],
        planPesca: [],
        zonas: [],
        estadoGuias: [],
        histEstPlan: [],
        trazabilidadGuias: [],
        listaGuias: [],
        empresaGuiaVirtual: [],
        placas: [],
        etiquetas: [],
        establecimiento: [],
        fabricas: [],
        fabricasDestino: [],
        fabricasOrigen: [],
        procesoOrigen: [],
        procesoDestino: [],
        areas: [],
        plantasDestino: [],
        guiaVirtual: [],
        InfoGuia: [],
        infoEtiquetasHijas: [],
        pedidoPesca: [],
        areaOrigen: [],
        areaDestino: [],
    },
    getters: {
        getUsuarios(state) {
            return state.usuarios
        },
        getUserId(state) {
            return state.user
        },
        getEmpresas(state) {
            return state.empresas
        },
        /*getRoles(state) {
            return state.roles
        },*/
        getDatos(state) {
            return state.datos
        },
        getReporte(state) {
            return state.reporte
        },
        getPlantas(state) {
            return state.plantas
        },
        getKardex(state) {
            return state.kardex
        },
        getStock(state) {
            return state.stock
        },
        getMovimiento(state) {
            return state.movimientos
        },
        getBinMov(state) {
            return state.binMov
        },
        getColores(state) {
            return state.colores
        },
        getDatosMonitoreo(state) {
            return state.monitoreo
        },
        getCamaroneras(state) {
            return state.camaroneras
        },
        getPiscinas(state) {
            return state.piscinas
        },
        getPlanPesca(state) {
            return state.planPesca
        },
        getMailDesgramos(state) {
            return state.mailDesgramos
        },
        getZonas(state) {
            return state.zonas
        },
        getEstadoGuias(state) {
            return state.estadoGuias
        },

        getHistEstPlanPesca(state) {
            return state.histEstPlan
        },
        getTrazabilidadGuias(state) {
            return state.trazabilidadGuias
        },
        getListaEstadosGuias(state) {
            return state.listaGuias
        },
        getEmpresa(state) {
            return state.empresaGuiaVirtual
        },
        getPlaca(state) {
            return state.placas
        },
        getEtiquetas(state) {
            return state.etiquetas
        },
        getEstablecimiento(state) {
            return state.establecimiento
        },
        getPlantaDestino(state) {
            return state.plantasDestino
        },
        getFabricas(state) {
            return state.fabricas
        },
        getFabricasOrigen(state) {
            return state.fabricasOrigen
        },
        getFabricasDestino(state) {
            return state.fabricasDestino
        },
        getAreaOrigen(state) {
            return state.areaOrigen
        },
        getAreaDestino(state) {
            return state.areaDestino
        },
        getProcesoOrigen(state) {
            return state.procesoOrigen
        },
        getProcesoDestino(state) {
            return state.procesoDestino
        },
        getAreas(state) {
            return state.areas
        },
        getGuiaVirtual(state) {
            return state.guiaVirtual
        },
        getInfoGuia(state) {
            return state.InfoGuia
        },

        getInfoEtiquetasHijas(state) {
            return state.infoEtiquetasHijas
        },
        getPedidoPesca(state) {
            return state.pedidoPesca
        },
    },
    mutations: {
        setUsuarios(state, usuarios) {
            state.usuarios = usuarios
        },
        setUserId(state, user) {
            state.user = user
        },
        setReporte(state, reporte) {
            state.reporte = reporte
        },
        setDatos(state, datos) {
            state.datos = datos
        },
        setEmpresas(state, empresas) {
            state.empresas = empresas
        },
        /*setRoles(state, roles) {
            state.roles = roles
        },*/
        setPlantas(state, plantas) {
            state.plantas = plantas
        },
        setKardex(state, kardex) {
            state.kardex = kardex
        },
        setMovimientos(state, movimientos) {
            state.movimientos = movimientos
        },
        setStock(state, stock) {
            state.stock = stock
        },
        setBinMov(state, binMov) {
            state.binMov = binMov
        },
        setColores(state, colores) {
            state.colores = colores
        },
        setDatosMonitoreo(state, monitoreo) {
            state.monitoreo = monitoreo
        },
        setCamaroneras(state, camaroneras) {
            state.camaroneras = camaroneras
        },
        setPiscinas(state, piscinas) {
            state.piscinas = piscinas
        },
        setPlanPesca(state, planPesca) {
            state.planPesca = planPesca
        },
        setMailDesgramos(state, mailDesgramos) {
            state.mailDesgramos = mailDesgramos
        },
        setZonas(state, zonas) {
            state.zonas = zonas
        },
        setEstadoGuias(state, estadoGuias) {
            state.estadoGuias = estadoGuias
        },

        setHistEstPlanPesca(state, histEstPlan) {
            state.histEstPlan = histEstPlan
        },
        setTrazabilidadGuias(state, trazabilidadGuias) {
            state.trazabilidadGuias = trazabilidadGuias
        },
        setListaEstadosGuias(state, listaGuias) {
            state.listaGuias = listaGuias
        },
        setEmpresaGuiaVirtual(state, empresaGuiaVirtual) {
            state.empresaGuiaVirtual = empresaGuiaVirtual
        },
        setPlaca(state, placas) {
            state.placas = placas
        },
        setEtiquetas(state, etiquetas) {
            state.etiquetas = etiquetas
        },
        setEstablecimiento(state, establecimiento) {
            state.establecimiento = establecimiento
        },
        setPlantaDestino(state, plantasDestino) {
            state.plantasDestino = plantasDestino
        },
        setFabricas(state, fabricas) {
            state.fabricas = fabricas
        },
        setFabricasDestino(state, fabricasDestino) {
            state.fabricasDestino = fabricasDestino
        },
        setFabricasOrigen(state, fabricasOrigen) {
            state.fabricasOrigen = fabricasOrigen
        },
        setAreas(state, areas) {
            state.areas = areas
        },
        setAreaOrigen(state, areaOrigen) {
            state.areaOrigen = areaOrigen
        },
        setAreaDestino(state, areaDestino) {
            state.areaDestino = areaDestino
        },
        setProcesoDestino(state, procesoDestino) {
            state.procesoDestino = procesoDestino
        },
        setProcesoOrigen(state, procesoOrigen) {
            state.procesoOrigen = procesoOrigen
        },
        setGuiaVirtual(state, guiaVirtual) {
            state.guiaVirtual = guiaVirtual
        },
        setInfoGuia(state, InfoGuia) {
            state.InfoGuia = InfoGuia
        },
        setInfoEtiquetasHijas(state, infoEtiquetasHijas) {
            state.infoEtiquetasHijas = infoEtiquetasHijas
        },
        setPedidoPesca(state, pedidoPesca) {
            state.pedidoPesca = pedidoPesca
        },
    },
    actions: {
        fetchEmpresas({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlBines/empresas')
                    .then(response => {
                        commit('setEmpresas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchPlantas({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlBines/plantas')
                    .then(response => {
                        commit('setPlantas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchKardex({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlBines/kardex', data)
                    .then(response => {
                        commit('setKardex', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchStock({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlBines/stock', data)
                    .then(response => {
                        commit('setStock', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchMovimientos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlBines/movimientos/' + data)
                    .then(response => {
                        commit('setMovimientos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchBinMov({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlBines/binMov/' + data)
                    .then(response => {
                        commit('setBinMov', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchColores({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/binesMovil/colors')
                    .then(response => {
                        commit('setColores', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchDatosMonitoreo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlBines/infoMovMoni/' + data)
                    .then(response => {
                        commit('setDatosMonitoreo', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        // Planificacion de pesca
        fetchCamaroneras({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlBines/camaroneras/' + data)
                    .then(response => {
                        commit('setCamaroneras', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchPiscinas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlBines/piscinas/' + data)
                    .then(response => {
                        commit('setPiscinas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchSavePlan({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlBines/savePlan', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchSavePlanEmail({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlBines/savePlanEmail', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchPlanPesca({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlBines/getPlanPesca/' + data)
                    .then(response => {
                        commit('setPlanPesca', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchPlanPescaRango({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlBines/getPlanificacion', data)
                    .then(response => {
                        commit('setPlanPesca', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchSaveDesgramo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlBines/saveDesgramos', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchMailDesgramos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlBines/mailDesgramos')
                    .then(response => {
                        commit('setMailDesgramos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchSendMailDesgramos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlBines/enviarMailDesgramos', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchAnuPlanCamaronera({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlBines/anularPlanCama', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchZonas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlBines/getZonaCam')
                    .then(response => {
                        commit('setZonas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchReporteEstadoGuias({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlBines/reporteEstadoGuias', {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchResumenGuias({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlBines/getResumenGuias/`, {
                        params: {
                            inicio: data['inicio'],
                            fin: data['fin'],
                            flag: data['flag'],
                            estado: data['estado'],
                        },
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchMotivoAnularGuiasVirtuales({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('api/auth/controlBines/getMotivoAnularGuiasVirtuales/')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchGetGuia({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlBines/getGuiaDetalle/' + data, {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchEmpresa({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlBines/getEmpresa?nombre=${data}`)
                    .then(response => {
                        commit('setEmpresaGuiaVirtual', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchPlaca({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlBines/getPlaca?co_empresa=${data}`)
                    .then(response => {
                        commit('setPlaca', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchFabricas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlBines/getFabricas?establecimiento_id=${data}`)
                    .then(response => {
                        commit('setFabricas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchFabricasDestino({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlBines/getFabricasDestino?establecimiento_id=${data}`)
                    .then(response => {
                        commit('setFabricasDestino', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchFabricasOrigen({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlBines/getFabricas?establecimiento_id=${data}`)
                    .then(response => {
                        commit('setFabricasOrigen', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchAreas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlBines/getAreas?co_fabrica=${data}`)
                    .then(response => {
                        commit('setAreas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchAreaOrigen({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlBines/getProcesoArea`, {
                        params: data,
                    })
                    .then(response => {
                        commit('setAreaOrigen', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchAreaDestino({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlBines/getProcesoArea`, {
                        params: data,
                    })
                    .then(response => {
                        commit('setAreaDestino', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchProcesoOrigen({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlBines/getProceso?co_fabrica=${data}`)
                    .then(response => {
                        commit('setProcesoOrigen', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchProcesoDestino({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlBines/getProceso?co_fabrica=${data}`)
                    .then(response => {
                        commit('setProcesoDestino', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchEtiquetas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlBines/getEtiquetas`, {
                        params: {
                            co_establecimiento: data['co_establecimiento'],
                            co_fabrica: data['co_fabrica'],
                            co_area: data['co_area'],
                            co_proceso: data['co_proceso'],
                            reservado_guiavirtual: data['reservadas'],
                            co_guiavirtual: data['co_guiavirtual'],
                            inicio: data['inicio'],
                            fin: data['fin'],
                        },
                    })
                    .then(response => {
                        commit('setEtiquetas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        clearEtiqueta({ commit }) {
            commit('setEtiquetas', [])
        },
        clearPlaca({ commit }) {
            commit('setPlaca', [])
        },
        clearFabrica({ commit }) {
            commit('setFabricas', [])
        },
        clearArea({ commit }) {
            commit('setAreas', [])
        },
        clearEmpresaGuiaVirtual({ commit }) {
            commit('setEmpresaGuiaVirtual', [])
        },
        clearPlantaDestino({ commit }) {
            commit('setPlantaDestino', [])
        },
        clearEstablecimiento({ commit }) {
            commit('setEstablecimiento', [])
        },
        clearEstablecimientoDestino({ commit }) {
            commit('setEstablecimiento', [])
        },
        clearFabricaOrigen({ commit }) {
            commit('setFabricasOrigen', [])
        },
        clearFabricaDestino({ commit }) {
            commit('setFabricasDestino', [])
        },
        clearAreaOrigen({ commit }) {
            commit('setAreaOrigen', [])
        },
        clearAreaDestino({ commit }) {
            commit('setAreaDestino', [])
        },
        clearProcesOrigen({ commit }) {
            commit('setProcesoOrigen', [])
        },
        clearProcesoDestino({ commit }) {
            commit('setProcesoDestino', [])
        },
        fetchPlantaDestino({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlBines/getPlantaDestino?nombre=${data}`)
                    .then(response => {
                        commit('setPlantaDestino', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchRegistrarGuiaVirtual({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/controlBines/registrarGuiaVirtual`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchAnularGuia({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/controlBines/anularGuiaVirtual`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchEtiquetasFaltantes({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlBines/getCantEtiquetasGuia?co_guiavirtual=${data}`)
                    .then(response => {
                        // commit("setInfoGuia", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchInfoGuia({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlBines/getInfoGuia?co_guiavirtual=${data}`)
                    .then(response => {
                        commit('setInfoGuia', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchModificarGuiaVirtual({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/controlBines/modificarGuiaVirtual`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchHistEstadosPlanPesca({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlBines/histEstadosPlan/' + data)
                    .then(response => {
                        commit('setHistEstPlanPesca', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchTrazabilidadGuias({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlBines/trazabilidadGuia', {
                        params: data,
                    })
                    .then(response => {
                        commit('setTrazabilidadGuias', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchReporteGuias({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlBines/getReporteGuias/' + data, {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchListaEstadosGuia({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlBines/listaEstadoGuias', {
                        params: data,
                    })
                    .then(response => {
                        // commit("setListaEstadosGuia", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchGetGuia({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlBines/getGuiaDetalle/' + data, {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchInfoEtiquetaAgrupada({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlBines/getInfoEtiquetaAgrupada?etiqueta=${data}`)
                    .then(response => {
                        //    commit("setInfoEtiquetasHijas", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchSellos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlBines/getSellos`, {
                        params: data,
                    })
                    .then(response => {
                        //    commit("setInfoEtiquetasHijas", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchAprobarGuia({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/controlBines/aprobarGuiaVirtual`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchPedidoPesca({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlBines/getPedidoPescaPropio/' + data)
                    .then(response => {
                        commit('setPedidoPesca', response.data)

                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchActualizarSellos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/controlBines/actualizarSellos`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchEnviarCorreo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/controlBines/enviarMailGuia`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchReceptarGuia({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/controlBines/receptarGuia?co_guiavirtual`, data)
                    .then(response => {
                        // commit("setInfoGuia", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchSubirPlanExcel({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/controlBines/subirPlanExcel`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
    },
}
